import { push } from 'connected-react-router';
import { createAction } from 'redux-actions';

import { getAppName } from 'app/router/selectors';
import { userLocale } from 'app/features/user/selectors';
import localizeLink from 'app/features/localization/localizeLink';

const notFoundRoute = createAction('NOT_FOUND_ROUTE');

function localRedirect(path, locationState = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const appName = getAppName(state);
    const locale = userLocale(state);

    dispatch(push(localizeLink(`/${appName}${path}`, locale), locationState));
  };
}

export { localRedirect, notFoundRoute };
